import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import { Theme } from 'ui_system/theme';
import { Spinner } from './Loader';

const ButtonStyled = styled.button`
  background: ${(props) =>
    props.inverted ? 'white' : props.theme.buttonBackgroundColor};
  border: ${(props) =>
    props.inverted ? `1px solid ${Theme.colors.inputs.border}` : 'none'};
  border-radius: 5px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  color: ${(props) =>
    props.inverted
      ? props.theme.buttonBackgroundColor
      : props.theme.buttonTextColor};

  margin: 50px 0px;

  display: flex;
  justify-content: center;
  align-items: center;

  opacity: ${(props) => (props.faded ? ' 0.3' : '1')};
`;

export const Button = ({
  disabled,
  text,
  onClick,
  faded,
  className,
  inverted,
}) => {
  const theme = useTheme();

  return (
    <ButtonStyled
      data-testid="login-button"
      className={className}
      disabled={disabled || faded}
      faded={faded}
      inverted={inverted}
      onClick={onClick}
    >
      {disabled ? (
        <Spinner
          testId="button-spinner"
          color={inverted ? theme.buttonBackgroundColor : theme.buttonTextColor}
        />
      ) : (
        text
      )}
    </ButtonStyled>
  );
};
